import defaultAvatar from '../assets/imgs/default-avatar.jpg';
import defaultCover from '../assets/imgs/default-cover.png';

export const DEFAULT_AVATAR = defaultAvatar;
export const DEFAULT_COVER = defaultCover;

export const handleAvatarError = (e) => {
  e.target.onerror = null;
  e.target.src = DEFAULT_AVATAR;
};
